import _slicedToArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import { useEffect, useState } from 'react';
import { usePrevious, usePortal } from '@uiw/react-baidu-map-utils';
import { jsx as _jsx } from "react/jsx-runtime";
var uid = 1;
export function CopyrightControlItem(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      children = _props.children,
      control = _props.control,
      bounds = _props.bounds;

  var _useState = useState(uid++),
      _useState2 = _slicedToArray(_useState, 1),
      id = _useState2[0];

  var _usePortal = usePortal(),
      container = _usePortal.container,
      Portal = _usePortal.Portal;

  var prevId = usePrevious(id);
  useEffect(function () {
    if (control) {
      control.addCopyright({
        id: id,
        bounds: bounds,
        content: container.innerHTML
      });
    }

    return function () {
      if (prevId && control) {
        control.removeCopyright(prevId);
      }
    };
  }, [bounds, children, container, control, id, prevId]);
  return /*#__PURE__*/_jsx(Portal, {
    children: children
  });
}